import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editorui/editoruiview
 */

/* globals document */
import View from "../view";
import Template from "../template";
import "../../theme/components/editorui/editorui.css";
/**
 * The editor UI view class. Base class for the editor main views.
 *
 * @extends module:ui/view~View
 */

var EditorUIView =
/*#__PURE__*/
function (_View) {
  _inherits(EditorUIView, _View);

  /**
   * Creates an instance of the editor UI view class.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   */
  function EditorUIView(locale) {
    var _this;

    _classCallCheck(this, EditorUIView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditorUIView).call(this, locale));
    /**
     * Collection of the child views, detached from the DOM
     * structure of the editor, like panels, icons etc.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection} #body
     */

    _this.body = _this.createCollection();
    /**
     * The element holding elements of the 'body' region.
     *
     * @private
     * @member {HTMLElement} #_bodyCollectionContainer
     */

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EditorUIView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(EditorUIView.prototype), "render", this).call(this);

      this._renderBodyCollection();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._bodyCollectionContainer.remove();

      return _get(_getPrototypeOf(EditorUIView.prototype), "destroy", this).call(this);
    }
    /**
     * Creates and appends to `<body>` the {@link #body} collection container.
     *
     * @private
     */

  }, {
    key: "_renderBodyCollection",
    value: function _renderBodyCollection() {
      var locale = this.locale;
      var bodyElement = this._bodyCollectionContainer = new Template({
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-reset_all', 'ck-body', 'ck-rounded-corners'],
          dir: locale.uiLanguageDirection
        },
        children: this.body
      }).render();
      document.body.appendChild(bodyElement);
    }
  }]);

  return EditorUIView;
}(View);

export { EditorUIView as default };